import React, { useEffect, useMemo,useState } from 'react';
import {

  View,
  Text,
  StatusBar,
  ScrollView,
  StyleSheet,
  Platform,
  Pressable,
  Linking,
  Alert,
  ActivityIndicator,
  TouchableOpacity,
  Image,
  TextInput,
  Modal,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import mystyles from '../../assets/styles/mystyles';
import {
  callApi,
  fetchAndStoreZipCode,
  getTimeMs,
  getUserId,
  setCurrentZipCode,
} from '../Helper/Helper';
import { useNavigation } from '@react-navigation/native';
import ConsumerSection from '../ConsumerSection/ConsumerSection';
import ProviderSection from '../ProviderSection/ProviderSection';
import Auth from '../../auth/AuthHelper';
import { Routes } from '../../navigation/Routes';
import learnmoreImg from '../../image/learnmore.png';
import viewmapImg from '../../image/viewmap.png';
import planaheadImg from '../../image/planahead.png';
const ENDPOINT_URL = 'https://api.eabu.net';

const Home = () => {
  const navigation = useNavigation();  // Add this line

  const [activeTab, setActiveTab] = useState('consumer');
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [zipInput, setZipInput] = useState('');
  const [currentZipModalVisible, setCurrentZipModalVisible] = useState(false);
  const [currentZipInput, setCurrentZipInput] = useState('');

  // State for Ad Details Popup
  const [adPopupVisible, setAdPopupVisible] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);

  // Store all ads
  const [ads, setAds] = useState([]);
  const [error, setError] = useState(null);

  const [identityChecking, setIdentityChecking] = useState(false);
  const [identityPendingVisible, setIdentityPendingVisible] = useState(false);







  const handleSellerPress = async () => {
    if (identityChecking) return;

    try {
      setIdentityChecking(true);
      const userId = await getUserId();
      // Expecting something like: { submitted: boolean, verified: boolean }
      const res = await callApi('GET', `/eabu-identity-check/${userId}`);
      const items = res?.Items || [];
      const result = items[0] || { submitted: false, verified: false };
      const submitted = !!result?.submitted;
      const verified = !!result?.verified;

      if (verified) {
        setActiveTab('provider');
        return;
      }

      // Not verified:
      if (!submitted && !verified) {
        navigation.navigate('IdentityScreen');
        return;
      }

      if (submitted && !verified) {
        setIdentityPendingVisible(true);
        return;
      }

      // Fallback: if API returns an unexpected shape, send user to IdentityScreen
      navigation.navigate('IdentityScreen');
    } catch (e) {
      Alert.alert(
        'Unable to check Identity',
        e?.message || 'Please try again in a moment.'
      );
    } finally {
      setIdentityChecking(false);
    }
  };

  const handleDeleteAccount = async () => {
    Alert.alert(
      'Delete Account',
      'Are you sure you want to delete your account? This action cannot be undone.',
      [
        {
          text: 'Cancel',
          style: 'cancel',
        },
        {
          text: 'Delete',
          style: 'destructive',
          onPress: async () => {
            try {
              const userId = await getUserId();
              const endpoint = `${ENDPOINT_URL}/eabu-delete`;
              const payload = {
                userId: userId
              };
              const res = await callApi('POST', endpoint, {body: payload});

              Alert.alert('Success', 'Your request to delete your account has been sent.');
              setMenuVisible(false);
            } catch (e) {
              Alert.alert('Error', e?.message || 'Failed to send delete request.');
            }
          },
        },
      ]
    );
  };

  useEffect(() => {
            const fetchData = async () => {
                try {
                    await fetchAndStoreZipCode();
                } catch (e) {
                    setError(e);
                } finally {
                    setLoading(false);
                }
            };

            fetchData().then(r => {});
        },
        []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const json = await callApi('GET', '/eabu-ad/active');
        setAds(json);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchData().then(r => {});
  },
    []);



  // Memoize ads data and randomization to prevent reshuffling on every render
  const displayedItems = useMemo(() => {
    const dataObject = JSON.parse(JSON.stringify(ads));
    const items = dataObject?.Items ?? [];

    // Sort by createdAt/CreatedAt descending (newest first)
    const sortedItems = [...items].sort((a, b) => {
      const ta = getTimeMs(a?.CreatedAt ?? a?.createdAt);
      const tb = getTimeMs(b?.CreatedAt ?? b?.createdAt);
      return tb - ta;
    });

    // Randomly pick only 5 items from the sorted list
    const arr = [...sortedItems];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr.slice(0, Math.min(5, arr.length));
  }, [ads]);

  if (loading) {
    return (
      <SafeAreaView style={mystyles.safe}>
        <StatusBar
          barStyle={Platform.OS === 'ios' ? 'light-content' : 'light-content'}
          backgroundColor="#0A84FF"
        />
        <View
          style={[
            mystyles.content,
            { alignItems: 'center', justifyContent: 'center', flex: 1 },
          ]}
        >
          <View
            style={{
              width: 84,
              height: 84,
              borderRadius: 42,
              backgroundColor: 'rgba(255,255,255,0.25)',
              borderWidth: 1,
              borderColor: 'rgba(255,255,255,0.35)',
              alignItems: 'center',
              justifyContent: 'center',
              // subtle shadow to feel like glass
              shadowColor: '#000',
              shadowOpacity: 0.15,
              shadowOffset: { width: 0, height: 8 },
              shadowRadius: 16,
              elevation: 8,
            }}
          >
            <ActivityIndicator size="large" color="#0A84FF" />
          </View>
          <Text style={{ marginTop: 12, opacity: 0.65 }}>Loading...</Text>
        </View>
      </SafeAreaView>
    );
  }



  const handleAdPress = async (ad) => {
    const { url } = ad;

    if (!url) {
      setSelectedAd(ad);
      setAdPopupVisible(true);
      return;
    }

    try {
      const canOpen = await Linking.canOpenURL(url);
      if (canOpen) {
        await Linking.openURL(url);
      } else {
        Alert.alert('Unable to open link', 'The provided URL is not supported on this device.');
      }
    } catch {
      Alert.alert('Error', 'Something went wrong while opening the link.');
    }
  };

  const handleSubmitPlanAhead = () => {
    if (zipInput.length < 5) {
      Alert.alert('Invalid Input', 'Please enter a valid 5-digit zipcode.');
      return;
    }
    setModalVisible(false);
    navigation.navigate('AllServices', { zipcode: zipInput });
    setZipInput('');
  };

  const handleSubmitCurrentZip = async () => {
    await setCurrentZipCode(currentZipInput);
    setCurrentZipModalVisible(false);
    setCurrentZipInput('');
    Alert.alert('Saved', 'Your current zipcode has been updated.');
  };

  const handleShowInMap = (address) => {
    if (!address) return;
    // Construct Google Maps URL query
    const query = encodeURIComponent(address);
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${query}`;

    Linking.openURL(mapUrl).catch(err => console.error('An error occurred', err));
  };

  const handleSignOut = async () => {
    try {
      await Auth.signOut();
    } catch (e) {
      Alert.alert('Sign out failed', e?.message || 'Please try again.');
      return;
    }

    setMenuVisible(false);
    setModalVisible(false);
    setActiveTab('consumer');

    navigation.reset({
      index: 0,
      routes: [{ name: Routes.SignUpScreen }],
    });
  };

  return (
  <SafeAreaView style={mystyles.safe}>
    <StatusBar
      barStyle={Platform.OS === 'ios' ? 'light-content' : 'light-content'}
      backgroundColor="#0A84FF"
    />

    <ScrollView
      contentContainerStyle={[
        mystyles.content,
        Platform.OS === 'web' && { paddingBottom: 170 },
      ]}
    >
      <View>
        <View style={styles.adHeaderRow}>
          <Text
            style={[
              mystyles.safe,
              { paddingVertical: 10, fontWeight: 'bold', color: '#555' },
            ]}
          >
            Advertisement
          </Text>

          <Pressable
            onPress={() => navigation.navigate('ProviderAdvertiseForm')}
            accessibilityRole="button"
            accessibilityLabel="Advertise here"
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            style={({ pressed }) => [styles.adHeaderLink, pressed && { opacity: 0.65 }]}
          >
            <Text style={styles.adHeaderLinkText}>Advertise here</Text>
          </Pressable>
        </View>

        <View>
          {displayedItems.map((ad, idx) => (
            <View key={ad.url || ad.title || String(idx)}>
              <Pressable
                onPress={() => handleAdPress(ad)}
                accessibilityRole="button"
                accessibilityLabel={`Sponsored advertisement${ad.title ? `: ${ad.title}` : ''}. Tap to learn more.`}
                android_ripple={{ color: 'rgba(0,0,0,0.05)' }}
                style={({ pressed }) => [
                  mystyles.card,
                  mystyles.adCard,
                  pressed && mystyles.adCardPressed,
                ]}
                hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
              >
                {/*<View style={mystyles.adHeader}>*/}
                {/*  <Text style={mystyles.adBadge}>Sponsored</Text>*/}
                {/*</View>*/}

                {/* Show ad image or fallback to website screenshot preview */}
                {(!!ad?.image || !!ad?.url) && (
                  <Image
                    source={{
                      uri: ad.image || `https://image.thum.io/get/width/640/crop/350/noanimate/${ad.url.startsWith('http') ? ad.url : 'https://' + ad.url}`
                    }}
                    style={{
                      width: '100%',
                      height: 150,
                      borderRadius: 6,
                      marginTop: 8,
                      marginBottom: 8,
                      backgroundColor: '#f0f0f0',
                    }}
                    resizeMode="cover"
                  />
                )}

                <Text style={mystyles.adTitle}>{ad.title || 'Save on your next service'}</Text>
                <Text style={mystyles.adSubtitle}>
                  {ad.subtitle || 'Exclusive offer available for a limited time'}
                </Text>
                {!ad.url && !!ad.description && (
                  <Text style={[mystyles.adSubtitle, { marginTop: 8, color: '#555' }]} numberOfLines={3}>
                    {ad.description}
                  </Text>
                )}

                {!!ad.zipcode && (
                  <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 14, justifyContent: 'space-between' }}>
                    {!!ad.phone && (
                      <TouchableOpacity
                        onPress={() => Linking.openURL(`tel:${ad.phone}`)}
                        style={styles.callButton}
                      >
                        <Text style={styles.callButtonText}>Call 📞</Text>
                      </TouchableOpacity>
                    )}
                    <Image
                      source={learnmoreImg}
                      style={[styles.footerIcon, { width: 60, height: 40 }]}
                    />
                    {!!ad.address && (
                      <Pressable
                        onPress={() => handleShowInMap(ad.address + ", " + ad.country + " " + ad.zipcode)}
                        style={({ pressed }) => ({
                          flexDirection: 'row',
                          alignItems: 'center',
                          backgroundColor: pressed ? '#E3F2FD' : '#F5F9FF',
                          paddingVertical: 6,
                          paddingHorizontal: 12,
                          borderRadius: 20,
                          borderWidth: 1,
                          borderColor: 'rgba(10, 132, 255, 0.15)',
                        })}
                        hitSlop={8}
                      >


                        <Image
                          source={viewmapImg}
                          style={[styles.footerIcon, { width: 40, height: 40 }]}
                        />

                      </Pressable>
                    )}
                  </View>
                )}
              </Pressable>
            </View>
          ))}
        </View>
      </View>
    </ScrollView>

    <View style={[styles.bottomBar, Platform.OS === 'web' && styles.bottomBarWeb]}>
    <View style={styles.tabContainer}>
      <Pressable
        onPress={() => setActiveTab('consumer')}
        style={[styles.tabButton, activeTab === 'consumer' && styles.tabButtonActive]}
      >
        <Text style={[styles.tabText, activeTab === 'consumer' && styles.tabTextActive]}>
          Buyer
        </Text>
      </Pressable>

      <Pressable
        onPress={handleSellerPress}
        disabled={identityChecking}
        style={[
          styles.tabButton,
          activeTab === 'provider' && styles.tabButtonActive,
          identityChecking && styles.tabButtonDisabled,
        ]}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
          <Text style={[styles.tabText, activeTab === 'provider' && styles.tabTextActive]}>
            Seller
          </Text>
          {identityChecking ? <ActivityIndicator size="small" color="#0A84FF" /> : null}
        </View>
      </Pressable>

      <Pressable
        onPress={handleSignOut}
        style={[styles.tabButton, styles.signOutTab]}
        accessibilityRole="button"
        accessibilityLabel="Sign out"
      >
        <Text style={[styles.tabText, styles.signOutText]}>Sign out</Text>
      </Pressable>
    </View>

    {activeTab === 'consumer' && (
      <ConsumerSection
        navigation={navigation}
        setModalVisible={setModalVisible}
        setMenuVisible={setMenuVisible}
        styles={styles}
      />
    )}

    {activeTab === 'provider' && <ProviderSection navigation={navigation} styles={styles} />}
    </View>

    <Modal
      animationType="fade"
      transparent={true}
      visible={menuVisible}
      onRequestClose={() => setMenuVisible(false)}
    >
      <View style={styles.menuOverlay}>
        <Pressable style={StyleSheet.absoluteFill} onPress={() => setMenuVisible(false)} />
        <View style={styles.menuPopup}>
          <Text style={styles.menuHeader}>Menu</Text>

          <View style={styles.menuGrid}>

            <TouchableOpacity style={styles.menuTab} onPress={() => { setMenuVisible(false); setModalVisible(true); }}>
              <View style={[styles.menuIconContainer, { backgroundColor: '#FFF4E5' }]}>
                <Image
                  source={planaheadImg}
                  style={[styles.menuTabIcon, { width: 40, height: 40 }]}
                />
              </View>
              <Text style={styles.menuTabText}>Plan Ahead</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.menuTab}
              onPress={() => { setMenuVisible(false); setCurrentZipModalVisible(true); }}
            >
              <View style={[styles.menuIconContainer, { backgroundColor: '#E8F5E9' }]}>
                <Image
                  source={planaheadImg}
                  style={[styles.menuTabIcon, { width: 40, height: 40 }]}
                />
              </View>
              <Text style={styles.menuTabText}>Set Current ZIP</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.menuTab}
              onPress={handleDeleteAccount}
            >
              <View style={[styles.menuIconContainer, { backgroundColor: '#FFEBEE' }]}>
                <Image
                  source={planaheadImg}
                  style={[styles.menuTabIcon, { width: 40, height: 40, tintColor: '#D32F2F' }]}
                />
              </View>
              <Text style={styles.menuTabText}>Delete Account</Text>
            </TouchableOpacity>


            {/*<TouchableOpacity style={styles.menuTab} onPress={() => { setMenuVisible(false); navigation.navigate('AllMyAsks'); }}>*/}
            {/*  <View style={[styles.menuIconContainer, { backgroundColor: '#E3F2FD' }]}>*/}
            {/*    <Image*/}
            {/*      source={require('../../image/allmyasks.png')}*/}
            {/*      style={[styles.menuTabIcon, { width: 40, height: 40 }]}*/}
            {/*    />*/}
            {/*  </View>*/}
            {/*  <Text style={styles.menuTabText}>My Asks</Text>*/}
            {/*</TouchableOpacity>*/}


          </View>

          <TouchableOpacity style={styles.menuCloseButton} onPress={() => setMenuVisible(false)}>
            <Text style={styles.menuCloseText}>Close</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>

    <Modal
      animationType="fade"
      transparent={true}
      visible={adPopupVisible}
      onRequestClose={() => setAdPopupVisible(false)}
    >
      <View style={styles.adModalOverlay}>
        <Pressable style={StyleSheet.absoluteFill} onPress={() => setAdPopupVisible(false)} />
        <View style={styles.adModalContent}>
          {selectedAd?.title ? <Text style={styles.adModalTitle}>{selectedAd.title}</Text> : null}
          {selectedAd?.subtitle ? <Text style={styles.adModalSubtitle}>{selectedAd.subtitle}</Text> : null}

          <ScrollView style={{ maxHeight: 200, marginVertical: 10 }}>
            <Text style={styles.adModalDescription}>
              {selectedAd?.description || 'No description available.'}
            </Text>
          </ScrollView>



          <TouchableOpacity
            onPress={() => Linking.openURL(`tel:${selectedAd.phone}`)}
            style={styles.callButton}
          >
            <Text style={styles.callButtonText}>Call 📞</Text>
          </TouchableOpacity>


          <TouchableOpacity
            style={styles.adModalCloseButton}
            onPress={() => setAdPopupVisible(false)}
          >
            <Text style={styles.adModalCloseText}>Close</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>

    <Modal
      animationType="slide"
      transparent={true}
      visible={modalVisible}
      onRequestClose={() => setModalVisible(false)}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Text style={styles.modalTitle}>Plan Ahead</Text>
          <Text style={styles.modalText}>Enter zipcode to find services</Text>

          <TextInput
            style={styles.input}
            onChangeText={setZipInput}
            value={zipInput}
            placeholder="Zipcode"
            keyboardType="numeric"
            maxLength={5}
            placeholderTextColor="#999"
          />

          <View style={styles.modalButtons}>
            <Pressable
              style={[styles.button, styles.buttonClose]}
              onPress={() => setModalVisible(false)}
            >
              <Text style={styles.textStyle}>Cancel</Text>
            </Pressable>
            <Pressable
              style={[styles.button, styles.buttonSubmit]}
              onPress={handleSubmitPlanAhead}
            >
              <Text style={styles.textStyle}>Submit</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>

    <Modal
      animationType="slide"
      transparent={true}
      visible={currentZipModalVisible}
      onRequestClose={() => setCurrentZipModalVisible(false)}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Text style={styles.modalTitle}>Current ZIP</Text>
          <Text style={styles.modalText}>Enter your current zipcode</Text>

          <TextInput
            style={styles.input}
            onChangeText={setCurrentZipInput}
            value={currentZipInput}
            placeholder="Zipcode"
            keyboardType="numeric"
            maxLength={5}
            placeholderTextColor="#999"
          />

          <View style={styles.modalButtons}>
            <Pressable
              style={[styles.button, styles.buttonClose]}
              onPress={() => setCurrentZipModalVisible(false)}
            >
              <Text style={styles.textStyle}>Cancel</Text>
            </Pressable>
            <Pressable
              style={[styles.button, styles.buttonSubmit]}
              onPress={handleSubmitCurrentZip}
            >
              <Text style={styles.textStyle}>Submit</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>

    {/* Identity pending message */}
    <Modal
      animationType="fade"
      transparent={true}
      visible={identityPendingVisible}
      onRequestClose={() => setIdentityPendingVisible(false)}
    >
      <View style={styles.identityOverlay}>
        <Pressable
          style={StyleSheet.absoluteFill}
          onPress={() => setIdentityPendingVisible(false)}
        />
        <View style={styles.identityCard}>
          <View style={styles.identityIconWrap}>
            <Text style={styles.identityIconText}>ID</Text>
          </View>

          <Text style={styles.identityTitle}>Verification in progress</Text>
          <Text style={styles.identityMessage}>
            We are reviewing your information, the process may take upto 10 business days. please
            check later!
          </Text>

          <Pressable
            onPress={() => setIdentityPendingVisible(false)}
            style={({ pressed }) => [styles.identityBtn, pressed && { opacity: 0.9 }]}
          >
            <Text style={styles.identityBtnText}>OK</Text>
          </Pressable>
        </View>
      </View>
    </Modal>
  </SafeAreaView>

);

};

const styles = StyleSheet.create({
  footerContainer: {
    backgroundColor: '#fff',
    paddingVertical: 10,
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
    paddingBottom: Platform.OS === 'ios' ? 20 : 10,
  },
  footerScrollContent: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
  },
  footerItem: {
    marginHorizontal: 10,
    alignItems: 'center',
  },
  footerIcon: {
    fontSize: 22,
    marginBottom: 0,
    color: '#333',

  },
  footerText: {
    fontSize: 6,
    fontWeight: '600',
    color: '#007AFF',
  },
  bottomBar: {
    backgroundColor: '#fff',
  },
  bottomBarWeb: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    maxWidth: 480,
    marginHorizontal: 'auto',
    paddingTop: 8,
    zIndex: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 12,
  },
  tabContainer: {
    flexDirection: 'row',
    marginHorizontal: 20,
    marginTop: 1,
    marginBottom: 20,
    backgroundColor: '#f1f3f5',
    borderRadius: 2,
    padding: 1,
  },
  tabButton: {
    flex: 1,
    paddingVertical: 1,
    alignItems: 'center',
    borderRadius: 25,
    justifyContent: 'center',
  },
  tabButtonActive: {
    backgroundColor: '#ffffff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  tabText: {
    fontWeight: '600',
    color: '#868e96',
    fontSize: 12,
  },
  tabTextActive: {
    color: '#343a40',
    fontWeight: '700',
  },
  tabButtonDisabled: {
    opacity: 0.7,
  },
  signOutTab: {
    backgroundColor: '#FFF1F2',
    borderWidth: 1,
    borderColor: '#FFE4E6',
  },
  signOutText: {
    color: '#DC2626',
    fontWeight: '800',
  },

  identityOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.55)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  identityCard: {
    width: '92%',
    maxWidth: 360,
    backgroundColor: '#fff',
    borderRadius: 20,
    paddingVertical: 20,
    paddingHorizontal: 18,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.06)',
    shadowColor: '#000',
    shadowOpacity: 0.18,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 10,
    alignItems: 'center',
  },
  identityIconWrap: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: '#EEF2FF',
    borderWidth: 1,
    borderColor: '#C7D2FE',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
  },
  identityIconText: {
    fontSize: 16,
    fontWeight: '900',
    color: '#3730A3',
    letterSpacing: 0.6,
  },
  identityTitle: {
    fontSize: 18,
    fontWeight: '800',
    color: '#0F172A',
    textAlign: 'center',
    marginBottom: 8,
  },
  identityMessage: {
    fontSize: 14,
    lineHeight: 20,
    color: '#475569',
    textAlign: 'center',
    marginBottom: 16,
  },
  identityBtn: {
    backgroundColor: '#0A84FF',
    paddingVertical: 12,
    paddingHorizontal: 22,
    borderRadius: 14,
    minWidth: 120,
    alignItems: 'center',
  },
  identityBtnText: {
    color: '#fff',
    fontWeight: '800',
    fontSize: 14,
  },
  footerSeparator: {
    width: 1,
    height: 30,
    backgroundColor: '#e0e0e0',
  },
  scrollIndicator: {
    position: 'absolute',
    right: 0,
    top: 0,
    paddingRight: 10,
    paddingTop: 4,
  },
  arrowText: {
    fontSize: 28,
    color: '#343a40',
    fontWeight: '300',
    paddingBottom: 4,
  },


  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
    backgroundColor: 'rgba(0,0,0,0.5)'
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: '80%'
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center'
  },
  input: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    width: '100%',
    borderColor: '#ccc',
    borderRadius: 5
  },
  modalButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 10
  },
  button: {
    borderRadius: 10,
    padding: 10,
    elevation: 2,
    minWidth: 100,
    alignItems: 'center'
  },
  buttonClose: {
    backgroundColor: '#6c757d',
  },
  buttonSubmit: {
    backgroundColor: '#007AFF',
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  menuOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  menuPopup: {
    width: '85%',
    backgroundColor: '#fff',
    borderRadius: 24,
    padding: 24,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 10,
  },
  menuHeader: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: 24,
  },
  menuGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    gap: 12,
  },
  menuTab: {
    width: '48%',
    backgroundColor: '#fff',
    borderRadius: 16,
    paddingVertical: 20,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#f0f0f0',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
    marginBottom: 12,
  },
  menuIconContainer: {
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 12,
  },
  menuTabIcon: {
    fontSize: 24,
  },
  menuTabText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#333',
  },
  menuCloseButton: {
    marginTop: 12,
    paddingVertical: 12,
    paddingHorizontal: 32,
    borderRadius: 20,
    backgroundColor: '#f8f9fa',
  },
  menuCloseText: {
    color: '#666',
    fontWeight: '600',
  },
  menuDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: '#ccc',
    width: '100%',
  },
  adModalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  adModalContent: {
    width: '90%',
    maxWidth: 340,
    backgroundColor: '#fff',
    borderRadius: 24,
    padding: 24,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.3,
    shadowRadius: 15,
    elevation: 10,
  },
  adModalTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#1a1a1a',
    marginBottom: 8,
    textAlign: 'center',
  },
  adModalSubtitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#007AFF',
    marginBottom: 12,
    textAlign: 'center',
  },
  adModalDescription: {
    fontSize: 15,
    lineHeight: 22,
    color: '#444',
    textAlign: 'center',
  },
  adModalCloseButton: {
    marginTop: 20,
    backgroundColor: '#007AFF',
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 25,
    elevation: 2,
  },
  adModalCloseText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '700',
  },
  infoPill: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  phonePill: {
    backgroundColor: '#E3F2FD',
    borderColor: '#BBDEFB',
  },
  infoPillText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#555',
  },


  callButton: {
    backgroundColor: '#34C759',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 6,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  callButtonText: {
    color: '#fff',
    fontSize: 11,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  adHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  adHeaderLink: {
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 12,
    backgroundColor: 'rgba(10,132,255,0.10)',
    borderWidth: 1,
    borderColor: 'rgba(10,132,255,0.18)',
  },
  adHeaderLinkText: {
    color: '#0A84FF',
    fontSize: 12,
    fontWeight: '700',
  },
});

export default Home;
